import { Image } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { SpaceTabPreview } from 'api/notifications';
import { RocketDocument20 } from 'components/atoms/icons';
import { useTranslation } from 'hooks/use-translation';
import { Header } from './components';
import styles from './group.module.css';

interface Props {
  spaceTab: SpaceTabPreview;
}

const Icon = styled(RocketDocument20)`
  margin-right: var(--spacing-04);
  color: var(--blue-60);
`;

const Logo = styled(Image)`
  margin-right: var(--spacing-04);
  width: 20px;
  height: 20px;
`;

export const SpaceTabHeader: FC<Props> = ({
  spaceTab: {
    name,
    logoUrl,
    project: { name: projectName },
    space: { name: spaceName },
  },
  children,
}) => {
  const titleFallback = useTranslation('fallbacks.document');
  const title = name ?? titleFallback;

  return (
    <Header className={styles.header}>
      <Header.Primary>
        {logoUrl != null ? <Logo alt={title} src={logoUrl} /> : <Icon />}
        <Header.PrimaryBlock>
          <div title={title} className={`${styles.title} ${styles.ellipsis}`}>
            {title}
          </div>
          <div
            className={`${styles.subtitle} ${styles.ellipsis}`}
          >{`${projectName} ${spaceName != null ? `/ ${spaceName}` : ''}`}</div>
        </Header.PrimaryBlock>
      </Header.Primary>
      <Header.Hanger>{children}</Header.Hanger>
    </Header>
  );
};
